import {AdapterProps} from '..';
import {ReactElement} from 'react';
import {createSpend, createIncome, createRefill} from 'core/Record';
import {addRecord as withRecord} from 'core/LifeCycle';

import {InputMode, handleCommand, useInputMode, updateMode} from 'store/UserInput';
import {toggleUndo} from 'store/UI';
import {useCoreState} from 'store/utils';
import {useDispatch} from 'ui/store';

import {clearSymbol} from 'ui/keyboard';
import {useStateDependentAdapters} from 'ui/adapters';
import {useKeyboardInput} from 'ui/utils/core';

function selectRecordFactory(mode: UserInputMode): RecordFactory {
  return {
    [InputMode.Spend]: createSpend,
    [InputMode.Income]: createIncome,
    [InputMode.Refill]: createRefill,
  }[mode];
}

export function useAppendRecord(): () => void {
  const callAdapters = useStateDependentAdapters();
  const clearKeyboard = useDispatch(handleCommand, clearSymbol);
  const showUndoButton = useDispatch(toggleUndo);
  const updateInputMode = useDispatch(updateMode);
  const coreState = useCoreState();
  const input = useKeyboardInput();
  const mode = useInputMode();

  return function appendRecord(): void {
    if (!input) return;
    const createRecord = selectRecordFactory(mode);
    const record = createRecord(input);
    const newSettings = withRecord(coreState, record);

    clearKeyboard();
    showUndoButton();
    callAdapters(newSettings);
    updateInputMode(InputMode.Spend);
  };
}

export function AppendRecord({children}: AdapterProps): ReactElement {
  const addRecord = useAppendRecord();
  return children({addRecord});
}
